import styles from "@/components/popup-close-button.module.css";
import { t } from "i18next";
import { JSX } from "react";

interface PopupCloseButtonProps {
	onClick: () => void;
}

function PopupCloseButton({ onClick }: PopupCloseButtonProps): JSX.Element {
	return (
		<button
			className={styles["close-button"]}
			onClick={onClick}
			title={t("close")}
			type="button"
		>
			<i>&#xe69a;</i>
		</button>
	);
}

export default PopupCloseButton;
